import React from "react";
import { Link } from "react-router-dom";

const NotFound: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-6">
      <h1 className="text-9xl font-bold text-red-500 mb-6">404</h1>
      <p className="text-2xl mb-4 text-black">Aradığınız sayfa bulunamadı.</p>
      <Link
        to="/"
        className="px-6 py-3 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition"
      >
        Ana Sayfaya Dön
      </Link>
    </div>
  );
};

export default NotFound;
